import { render, staticRenderFns } from "./spu-table.vue?vue&type=template&id=1a7c1d2e"
import script from "./spu-table.vue?vue&type=script&lang=js"
export * from "./spu-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports